

















































import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../../store/modules/MembershipState'
import { downloadState } from '../../../store/modules/DownloadState'
import {
  DownloadLinkInfo,
  DownloadStatus
} from '../../../modules/class/Downloads'
import axios from 'axios'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import JsonUtil from '../../../modules/util/JsonUtil'
import PathUtil from '../../../modules/util/PathUtil'
import { createCustomEvent } from '../../../modules/CustomEvent'
import {
  SapLoginInfo,
  ssoLogin,
  ErrorModalData
} from '../../../modules/util/SapUtil'
import UidCookie from '../../../modules/util/UidSetCookie'

// Component
import CountryRegion from './CountryRegion.vue'
import ManualModal from './ManualModal.vue'

// ファイル権限チェック戻り値
export interface ResultAuth {
  status: number
  result: boolean
  errorCode: number
  level: number
  memberLevel: number
  haserror: boolean
  errordata: ErrorFormResponse
}

@Component({
  components: {
    CountryRegion,
    ManualModal
  }
})
export default class DownloadLink extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data
  private waitingFileInfo: DownloadLinkInfo | null = null // 一時停止時の退避用
  private waitingUrl: URL | null = null

  private modalType = 0 // -1:Error 0:非表示 1:マニュアルDL 2:HealthCare
  private manualAgree = false
  private healthCareCheck = false
  private errorMsg = ''

  private downloadAddJsonCall = '' // コールバックに引き継ぐための変数
  private downloadUrlCall: URL | null = null // コールバックに引き継ぐための変数
  private downLoadInfoCall: DownloadLinkInfo | null = null // コールバックに引き継ぐための変数

  private uidcookie = new UidCookie()

  // --------------------------------------------------------------------------------------------------------------------
  // computed

  /**
   * エラーモーダルの表示・非表示
   */
  get isErrorModalVisible(): boolean {
    return this.errorMsg !== '' && this.modalType === -1
  }

  /**
   * Country選択モーダルの表示・非表示
   */
  get isCountryModalVisible(): boolean {
    return (
      this.waitingFileInfo != null &&
      this.modalType === 2 &&
      this.healthCareCheck === false
    )
  }

  /**
   * マニュアルダウンロード同意モーダルの表示・非表示
   */
  get isManualModalVisible(): boolean {
    return (
      this.waitingFileInfo != null &&
      this.modalType === 1 &&
      this.manualAgree === false
    )
  }

  // watch download status
  // download statusをwatchし、4:再トライとなった場合にDLを行う
  get watchDownladStatus(): number {
    // DL用ステータスを監視し、4:DL再トライとなった、リンククリックイベントを再実行
    if (membershipState.pdfDownloadStatus === DownloadStatus.ReDownloadTry) {
      this.restartDownload()
    }
    return membershipState.pdfDownloadStatus
  }

  // --------------------------------------------------------------------------------------------------------------------
  // hocks

  // -------------------------------------------------------------------------------------------------------------------
  // private methods

  /**
   * VuexのState情報をクリアする
   */
  private clearState() {
    // 権限Levelを初期化
    membershipState.addLevel(0)
    // DL対象URLを空に
    membershipState.addAccessUrl('')
    // DLステータスを0:認証前に設定
    membershipState.addDownloadStatus(DownloadStatus.Unauthorized)
  }

  /**
   * 国を選択モーダルで国選択
   */
  private selectCountry() {
    this.healthCareCheck = true
    this.closeModal()
    this.restartDownload()
  }

  /**
   * マニュアルダウンロード同意モーダルに同意する
   */
  private agreeManual() {
    this.manualAgree = true
    this.closeModal()
    this.restartDownload()
  }

  /**
   * ダウンロード処理を再開
   */
  private restartDownload() {
    // 退避させていたURLを取得
    const url = this.waitingUrl
    this.waitingUrl = null
    if (url) {
      this.start(url)
    }
  }

  /**
   * モーダルを非表示にする
   */
  private closeModal() {
    this.modalType = 0
  }

  /**
   * 外部リンクかを判定
   */
  private isExternalLink(url: URL) {
    return !(window.location.origin.toString() === url.origin.toString())
  }

  /**
   * ダウンロード
   */
  private async download(url: URL, info: DownloadLinkInfo): Promise<void> {
    // DL対象URLを設定
    membershipState.addAccessUrl(url.pathname)

    // DLステータスを0:認証前に設定
    membershipState.addDownloadStatus(DownloadStatus.Unauthorized)

    // コールバック後に引き継ぐためにセット
    this.downLoadInfoCall = info

    // 対象ファイルの権限チェック
    await this.authCheck(url)
  }

  /**
   * URLの認証チェックを行う
   */
  private async authCheck(url: URL) {
    this.downloadUrlCall = url
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginAuthResponse
    })
  }

  /**
   * SAP Download登録 コールバック関数
   * @param response SAPレスポンス
   */
  private async verifyLoginAuthResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
    regToken: string
  }) {
    let auth: ResultAuth = {
      status: -1,
      result: false,
      errorCode: -1,
      level: 0,
      memberLevel: 0,
      haserror: false,
      errordata: {}
    }

    let accountInfo = {
      UID: membershipState.sapLoginInfo.UID,
      UIDSignature: membershipState.sapLoginInfo.UIDSignature,
      signatureTimestamp: membershipState.sapLoginInfo.signatureTimestamp
    }
    if (response.errorCode === 0) {
      accountInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(accountInfo)
    }

    const url = this.downloadUrlCall
    if (url !== null) {
      const form = JSON.stringify({
        url: url.origin + '/' + url.pathname,
        token: url.searchParams.get('token') ?? '',
        accountInfo: accountInfo
      })
      const res = await axios.post(
        PathUtil.makePath('/member/api/level_check'),
        form
      )
      if (res === undefined || res.status !== 200) {
        // エラーメッセージの表示
        this.showErrorModal(this.$t('download.document_level_error').toString())
        return
      }

      auth = {
        status: res.status,
        result: res.data.result,
        errorCode: res.data.error_code,
        level: res.data.level,
        memberLevel: res.data.member_level,
        haserror: false,
        errordata: {}
      }

      // APIの仕様からstatusやresultからエラーと判断できないためerrordataがあればエラーとする
      const model = res.data.errordata || null
      if (model !== null) {
        // エラー有
        auth.haserror = true
        auth.errordata = JsonUtil.jsonToObject<ErrorFormResponse>(
          ErrorFormResponse,
          model
        )
      }
    }

    this.continuedDownload(auth)
  }

  private async continuedDownload(authres: ResultAuth) {
    // 親コンポーネントのエラー初期化
    this.$emit('clearerror')

    // 権限チェックAPIのエラー
    if (authres.haserror) {
      // 親コンポーネントにエラーメッセージを返却
      this.$emit('downloaderror', authres.errordata)
      return
    }

    // 権限チェックAPIの通信エラー
    if (authres.status !== 200) {
      // VuexのState情報をクリアして終了
      this.clearState()
      throw new Error('Communication error')
    }

    // DLの許可されなかったとき
    // ログインモーダルを表示して中断
    if (!authres.result) {
      // APIから返却されたLevelを設定
      // （ログインモーダルのCreateAccountリンクがクリックされた際に使用する）
      membershipState.addLevel(authres.level)

      // DLステータスを変更
      // 未認証の場合、3:未ログインに設定
      // 権限不足の場合、2:権限不足に設定
      membershipState.addDownloadStatus(
        authres.memberLevel === -1
          ? DownloadStatus.NotLoggedIn
          : DownloadStatus.UnderLevels
      )

      if (authres.memberLevel < 0) {
        // ログインしていないのでセントラルログインページに遷移
        // ログイン後はPDFのURLにアクセスする
        const url = this.downloadUrlCall?.toString() ?? window.location.href
        ssoLogin(url, 'gigya-login-screen')
      } else {
        // ログインはしているが、レベルが足りない
        membershipState.addIsRegisterAdditionalModalVisible(true)
      }
      return
    }

    // DLステータスを1:DL,OKに設定
    membershipState.addDownloadStatus(DownloadStatus.DownloadOK)

    // Level=9のときは処理をスキップ
    const url = this.downloadUrlCall
    if (authres.level !== -1) {
      const info = this.downLoadInfoCall
      // GTMへイベント送信
      if (url !== null && info !== null) {
        await this.sendGTMEvent(info, authres)
        // DL履歴登録
        await this.addDownloadHistory(url, info)
      }
    } else {
      // ダウンロード実行
      if (url !== null) {
        await this.doDownloadSuccess(url)
      }
    }
  }

  /**
   * DL時にGTM連携用のイベントを送信する
   */
  private async sendGTMEvent(info: DownloadLinkInfo, authResult: ResultAuth) {
    // silberEgg側でGTM内で外部通信を行っており、画面遷移直前だとエラーになるためここで定義
    createCustomEvent('start-pdf-download-for-silverEgg', { info: info })

    // Regionから製品カテゴリのサブカテゴリ名を取得
    const subcategoryname: string[] = []
    for (const region of info.region) {
      if (region.type === 'product') {
        subcategoryname.push(region.subcategoryName)
      }
    }

    // アナリティクス
    // 失敗しても処理継続する
    const url = this.downloadUrlCall
    window.dataLayer = window.dataLayer || []
    if (url !== null) {
      window.dataLayer.push({
        'document-dl': url.origin + url.pathname + url.search,
        'document-level': authResult.level,
        'document-product-category': subcategoryname.join('|'),
        event: 'DocumentDlEvent'
      })
    }
  }

  /**
   * ダウンロード履歴登録
   */
  private async addDownloadHistory(url: URL, info: DownloadLinkInfo) {
    this.downloadAddJsonCall = JSON.stringify({
      url: url.origin + url.pathname,
      title: info.title,
      content_type: info.contentType,
      file_type: info.fileType,
      file_size: info.fileSizeOrg
    })

    this.downloadUrlCall = url
    // verifyLoginJSとダウンロード登録
    this.verifyLoginDowndloadAdd()
  }

  private verifyLoginDowndloadAdd() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginDownloadAddResponse
    })
  }

  /**
   * SAP Download登録 コールバック関数
   * @param response SAPレスポンス
   */
  private async verifyLoginDownloadAddResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }
      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      const res = await axios.post(
        PathUtil.makePath('/member/api/download_history_add'),
        this.downloadAddJsonCall
      )
      if (res === undefined || res.status !== 200) {
        // システムエラー
      } else {
        if (res.data.result !== 'success') {
          // 登録失敗
          const resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
            ErrorFormResponse,
            res.data.errordata || {}
          )
          // 親コンポーネントにエラーメッセージを返却
          this.$emit('downloaderror', resultError)
        }
        // 履歴登録成功した場合、特に何もしない
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
    // ダウンロード実行
    const url = this.downloadUrlCall
    if (url !== null) {
      await this.doDownloadSuccess(url)
    }
  }

  /**
   * 認証に成功したファイルのDL
   */
  private async doDownloadSuccess(url: URL) {
    // ファイルダウンロード
    // DLステータスが1:DL,OKの場合、ダウンロードする
    if (
      membershipState.pdfDownloadAccessUrl === url.pathname &&
      membershipState.pdfDownloadStatus === DownloadStatus.DownloadOK
    ) {
      // ダウンロードを行うので、変数を初期化しておく
      this.downloadUrlCall = null

      // VuexのState情報をクリア
      this.clearState()

      this.pageTransition(url.href)
    }
  }

  /**
   * ページ遷移を行う
   */
  private pageTransition(href: string) {
    const a = document.createElement('a')
    a.href = href
    a.click()
  }

  /**
   * エラーモーダルを表示する
   */
  private showErrorModal(msg: string) {
    this.modalType = -1
    this.errorMsg = msg
  }

  // -------------------------------------------------------------------------------------------------------------------
  // public methods

  /**
   * ダウンロードを開始する
   *
   * - ヘルスケアのファイルで非表示国が設定されている場合、国選択ダイアログ表示し中断
   * - マニュアルヘルスケアのファイルで非表示国が設定されている場合、国選択ダイアログ表示し中断
   */
  public async start(url: URL): Promise<void> {
    if (this.isExternalLink(url)) {
      // 外部リンクの場合、遷移
      this.pageTransition(url.href)
      return
    }

    // リンク情報を退避
    this.waitingUrl = url

    // ぺージ情報を取得
    let pageMap = downloadState.pageMap
    if (pageMap.size === 0) {
      await downloadState.fetchPageMap()
      pageMap = downloadState.pageMap
    }

    // URLからページ情報を取得
    const key = url.origin + url.pathname
    const info = pageMap.get(key)
    if (!info) {
      this.showErrorModal(this.$t('download.not_found_error').toString())
      return
    }

    if (info.contentTypeCode === 'manuals' && this.manualAgree === false) {
      // マニュアルダウンロードの同意ダイアログ表示
      this.modalType = 1
      this.waitingFileInfo = info
    } else if (
      info.healthCare &&
      info.invisibleCountry.length > 0 &&
      this.healthCareCheck === false
    ) {
      // Health CareのPDFで表示禁止の国・地域が指定していれば、選択ダイアログ表示
      this.modalType = 2
      this.waitingFileInfo = info
    } else {
      // ダイアログ表示が無いとき
      await this.download(url, info)
    }
  }
}
